import { ReactNode } from 'react';

import { Box, alpha, useTheme, SxProps, Theme } from '@mui/material';

type LoadingOverlayProps = {
  loading?: boolean;
  children: ReactNode;
  radius?: number | string;
  sx?: SxProps<Theme>;
};

export const LoadingOverlay = ({
  loading,
  children,
  radius = 12,
  sx,
}: LoadingOverlayProps) => {
  const theme = useTheme();

  return (
    <Box sx={{ position: 'relative', borderRadius: radius, ...sx }}>
      {children}

      {loading && (
        <Box
          aria-hidden
          sx={{
            position: 'absolute',
            inset: 0,
            borderRadius: `${radius}px`,
            pointerEvents: 'none',
            overflow: 'hidden',

            background: alpha(
              theme.palette.fog?.['90'] ?? theme.palette.grey[200],
              0.9
            ),
            backdropFilter: 'blur(2px)',
            filter: 'saturate(0.7)',

            '&::after': {
              content: '""',
              position: 'absolute',
              inset: 0,
              transform: 'translateX(-100%)',
              background:
                'linear-gradient(90deg, transparent, rgba(255,255,255,.55), transparent)',
              animation: 'shimmer 1.25s ease-in-out infinite',
            },

            '@keyframes shimmer': {
              '100%': { transform: 'translateX(100%)' },
            },

            '@media (prefers-reduced-motion: reduce)': {
              '&::after': { animation: 'none' },
            },
          }}
        />
      )}
    </Box>
  );
};
